import React from "react";

export default function CallPopup(props){
    
    return(
        <>
        <div className="CallPopup rounded shadow">
            <div className="CallAvatar rounded-circle" style={{backgroundImage:`url(${props.image})`}}></div>
            <div className="CallerInfo">
                <h5 className="text-white">{props.name}</h5>
                <p>Incoming Call</p>
            </div>
            <i onClick={props.onClose} className="fa-solid fa-phone-flip text-white bg-danger"></i>
            <i onClick={props.onAccept} className="fa-solid fa-phone text-white bg-primary"></i>
        </div>
        </>
    );

}